import { View, PLATFORM_DESKTOP_SMALL} from "@gaming/srvg-classes-core";
import { CuprosterWidget } from "../../widgets/View/VfWidget/CuprosterWidget";
import { LivetableWidget } from "../../widgets/View/VfWidget/LivetableWidget";
import { RosterWidget } from "../../widgets/View/VfWidget/RosterWidget";

export class RoundContainerView extends View {
    cuprosterWidget: CuprosterWidget;
    rosterWidget: RosterWidget;
    activeGroups: string[];
    groupTableWidgets:  LivetableWidget[];
    options: any;

    constructor(options) {
        options = options || {};
        super(options);


        this.activeGroups = [];
        this.groupTableWidgets= [];

        if (options.numberOfTables){
            for (var i = 0; i < options.numberOfTables; i++){
                this.activeGroups[i] = 'A';
            }
        }

        this.options = options;
        if (typeof this.options.showTeamAbbr === "undefined"){
            this.options.showTeamAbbr = true;
        }
    }

    handleDomInstantiated() {
        var that = this;
        super.handleDomInstantiated();
        if (srvg.widgets.enabled && srvg.widgets.widgets['cuproster'].enabled
            && !srvg.widgets.widgets['roster'].enabled ) {
            this.cuprosterWidget = this.addSubView(new CuprosterWidget({
                showFlags: true,
                show3rdPlace: true,
                cuprosterMode: 'vertical',
                widgetGroup: this.name,
                selector: this.selector + ' div.cuprosterWidget',
                platform: PLATFORM_DESKTOP_SMALL,
                subscribeToLiveScoreMatch: false,
                showTeamAbbr: this.options.showTeamAbbr
            }));
        } else if(srvg.widgets.widgets['roster'].enabled){
            this.rosterWidget = this.addSubView(new RosterWidget({
                showFlags: true,
                show3rdPlace: true,
                cuprosterMode: 'vertical',
                widgetGroup: this.name,
                selector: this.selector + ' div.rosterWidget',
                platform: PLATFORM_DESKTOP_SMALL,
                subscribeToLiveScoreMatch: false,
                showTeamAbbr: this.options.showTeamAbbr
            }));
        }
        if (srvg.widgets.enabled && srvg.widgets.widgets['livetable'].enabled){
            for (var i in this.activeGroups){
                this.groupTableWidgets[i] = this.addSubView(new LivetableWidget({
                    widgetGroup: this.name,
                    selector: this.selector + ' div.groupTableWidget' + i,
                    group: this.activeGroups[i] || null,
                    platform: PLATFORM_DESKTOP_SMALL,
                    showGroupHeader: true,
                    showActiveGroupBorder: false,
                    subscribeToLiveScoreMatch: false,
                    showTeamAbbr: this.options.showTeamAbbr,
                    diff: false,
                    score: true,
                    played: true,
                    change: true,
                    onLoad: function() { that.updateLivetables() }
                }));
            }
        }
    }

    setOptions(options:any, fromConstructor?:boolean) {
        super.setOptions(options, fromConstructor);
    }

    showGroupStageData(){
        this.toggleClass('groupStage', 'leagueStage');
    }

    showLeagueStageData(){
        this.toggleClass('leagueStage', 'groupStage');
    }

    private toggleClass(activeClass, removeClass){
        this.$domNode.addClass(activeClass).removeClass(removeClass);
    }

    private updateLivetables(){
        if (this.groupTableWidgets.length > 0) {
            for (var i in this.activeGroups) {
                //console.log("updateLivetables", this.activeGroups[i]);
                this.groupTableWidgets[i].setGroup(this.activeGroups[i]);
            }
        }
    }

    setGroups(groups){
        for(var i in groups){
            this.activeGroups[i] = groups[i];
        }
        this.updateLivetables();
    }


}